<div class="work-card margin-bottom-8">
  <!-- User Name (only in admin/approval views) -->
  @if (showUserName() && absence().creator) {
    <p class="work-text-color-light margin-bottom-4">
      <small>{{ absence().creator?.firstName }} {{ absence().creator?.lastName }}</small>
    </p>
  }

  <!-- Type & Status Row -->
  <div class="flex space-between vertical-center margin-bottom-8">
    <div>
      <strong>{{ absence().timerecordtype?.name || '-' }}</strong>
      @if (isPartialAbsenceType(absence().timerecordtypeId)) {
        <span> ({{ absence().percentage }}%)</span>
      }
    </div>
    <work-ui-badge
      size="small"
      [text]="absence().status?.name || '-'"
      [variant]="getStatusVariant(absence().status?.name)" />
  </div>

  <!-- Date Range -->
  <div class="flex gap-8 margin-bottom-8">
    <p>{{ (absence() | formatAbsenceDateRange) || '-' }}</p>
  </div>

  <!-- Comment -->
  @if (absence().comment) {
    <p class="margin-bottom-8">
      <small class="work-text-color-light">{{ absence().comment }}</small>
    </p>
  }

  <!-- Documents -->
  @if (absence().documents && absence().documents!.length > 0) {
    <div class="margin-bottom-8">
      @for (document of absence().documents; track document.id) {
        <a [href]="document.fileSrc | prependServerToFileSrc" target="_blank" class="absenzen-card__document-link">
          {{ document.name }}
        </a>
      }
    </div>
  }

  <!-- Actions -->
  <div class="flex gap-8 flex-end">
    @if (showApprovalActions()) {
      <work-ui-button
        (buttonClick)="approveClick.emit(absence())"
        text="GENEHMIGEN"
        size="small"
        variant="primary" />
      <work-ui-button
        (buttonClick)="rejectClick.emit(absence())"
        text="ABLEHNEN"
        size="small"
        variant="secondary" />
    }
    @if (canEdit()) {
      <work-ui-button
        (buttonClick)="editClick.emit(absence())"
        [iconOnly]="true"
        iconName="edit"
        size="small"
        variant="secondary" />
    }
    @if (canDelete()) {
      <work-ui-button
        (actionConfirmResult)="deleteClick.emit(absence())"
        [iconOnly]="true"
        workUiShowConfirmActionModal
        iconName="delete"
        size="small"
        variant="secondary" />
    }
  </div>
</div>
